module.exports = __webpack_public_path__ + "static/media/ic-service-active.6705b404.svg";